export const title = "Customer Remaining Package - By Bought Package Name";

export const tableWidth = "w-[53.5rem]";

export const paramSettings = [
  // {
  //   name: "dari",
  //   field: "tanggal_transaksi",
  //   type: "date",
  //   format: "yyyy-MM-dd 00:00:00",
  //   operator: ">=",
  //   default: new Date(),
  //   nullable: false,
  // },
  // {
  //   name: "sampai",
  //   field: "tanggal_transaksi",
  //   type: "date",
  //   format: "yyyy-MM-dd 23:59:59",
  //   operator: "<=",
  //   default: new Date(),
  //   nullable: false,
  // },
];

export const generateDefaultReportParams = () => {
  const defaultParam = {};

  for (let param of paramSettings) {
    defaultParam[param.name] = param.default;
  }

  return defaultParam;
};

export const groupSetting = {
  name: "Package Item",
  field: "product_name",
  data_field: undefined,
};

export const columnSettings = [
  {
    name: "NO",
    field: "no",
    type: "number",
    width: "w-[3.5rem]",
    layout: "col-start-center",
  },
  {
    name: "CODE",
    field: "customer_code",
    type: "string",
    width: "w-[6rem]",
    layout: "col-start-start",
  },
  {
    name: "NAME",
    field: "customer_name",
    type: "string",
    width: "w-[11rem]",
    layout: "col-start-start",
  },
  {
    name: "PACKAGE ITEM",
    field: "product_name",
    type: "string",
    width: "w-[12rem]",
    layout: "col-start-start",
  },
  {
    name: "QTY",
    field: "quantity",
    type: "number",
    width: "w-[4rem]",
    layout: "col-start-end",
  },
  {
    name: "BOUGHT AT",
    field: "transaction_date",
    type: "date",
    format: "dd/MM/yyyy",
    width: "w-[8rem]",
    layout: "col-start-center",
  },
  // {
  //   name: "INV. NO",
  //   field: "number",
  //   type: "string",
  //   layout: "col-start-start",
  //   width: "w-[26rem]",
  // },
  {
    name: "PACKAGE NAME",
    field: "product_package_name",
    type: "string",
    layout: "col-start-start",
    width: "w-[26rem]",
  },
];
